import { Container } from "./styles";
import Lottie from 'react-lottie';
import animationData from '../../lotties/door-404.json';

export function Door404() {

    const defaultOptions = {
        loop: true,
        animationData: animationData,
    }

    return (
        <Container>
            <div className='lottie'>
                <div>
                    <Lottie options={defaultOptions} height={300} width={300} />
                </div>
            </div>
        </Container>

    );
}